import { Api } from './Api'

class CellPhoneValidation {
  post (customerId, cellPhone) {
    const body = {
      cell_phone: cellPhone
    }
    return fetch(`${Api.getBaseUrl()}cellphonevalidation/${customerId}`, Api.getOptions('POST', body))
  }
}

export default CellPhoneValidation
